import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// About Us page sections
import Team from "pages/LandingPages/AboutUs/sections/Team";
import Featuring from "pages/LandingPages/AboutUs/sections/Featuring";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images

const content = {
  "who-we-are": {
    header: "Who We Are",
    sections: [
      "AF1985 Inc. Real Estate Solutions: Simplifying Complexity in Real Estate Development",
      "At AF1985 INC., we believe that real estate development is a multifaceted endeavour, but we have mastered the art of simplicity in delivering exceptional results. As a renowned real estate developer and owner, our unique approach is driven by innovative solutions, unwavering commitment to customer care, seamless collaboration, and an uncompromising commitment to first-class quality. Through these principles, we ensure the success of our clients, owners, partners, residents, and employees, maximizing value at every step.",
      "Established as the real estate development, investment, and property management division of AF1985 INC., we take pride in being the guiding force that navigates the complex landscape of real estate development, construction, financing, operations, and management. With a rich history spanning four decades, we have been instrumental in delivering successful real estate programs for public, private, and non-profit clients across the globe with focus on US and Africa.",
    ],
    extra: <Featuring />,
  },
  team: {
    header: "Our Team",
    sections: ["Meet our team of experts dedicated to providing quality services"],
    extra: <Team />,
  },
  "values-and-commitment": {
    header: "Values And Commitment",
    sections: [
      "AF1985 INC.: Building a Better Future through Equal Treatment and Innovation",
      "At AF1985 INC., our approach is rooted in a simple but powerful principle: treat others equally as we would want to be treated. We believe in creating an inclusive environment that empowers the best and brightest in our industry, embracing their passion, creativity, and ideas. Equipped with the latest technology, our team members are enabled to excel in their roles and deliver exceptional results.",
      "Central to our philosophy is the establishment of genuine partnerships with OEM suppliers and subcontractors. These relationships begin with fair bidding practices and efficient project management. We uphold a zero-tolerance hard-hat policy and prioritize industry-leading safety practices, ensuring the well-being of everyone involved in our projects. As pioneers, we have also introduced a contractor-led insurance program, providing an added layer of security, risk management and peace of mind.",
      "Our commitment to communities in which we build goes beyond construction. We treat these communities as our own, striving to enhance them through sustainable practices that reduce waste and promote environmental responsibility. Additionally, we actively engage in programs that give back to the people who share these spaces, fostering a sense of unity and social responsibility.",
      "For our valued clients, our approach has resulted in a fully integrated real estate, architecture, design, engineering, and construction model. We deliver creative solutions that propel their businesses to success, while maintaining rigorous project management and fiscal",
    ],
    extra: <Featuring />,
  },
};

function AboutUs({ index }) {
  const data = content[index];
  return (
    <>
      <DefaultNavbar routes={routes} />
      <MKBox
        // minHeight="90vh"
        width="100%"
        sx={{
          // backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
          //   `${linearGradient(
          //     rgba(gradients.dark.main, 0.6),
          //     rgba(gradients.dark.state, 0.6)
          //   )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
          paddingTop: 20,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            sx={{ mx: "auto", textAlign: "center" }}
          >
            <MKTypography
              variant="h1"
              color="grey"
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              {data?.header}
            </MKTypography>
            {data?.sections?.map((section) => (
              <MKTypography
                sx={{ textAlign: "left" }}
                variant="body1"
                color="grey"
                opacity={0.9}
                mt={1}
                mb={3}
              >
                {section}
              </MKTypography>
            ))}

            <MKTypography variant="h6" color="white" mt={8} mb={1}>
              Find us on
            </MKTypography>
            <MKBox display="flex" justifyContent="center" alignItems="center">
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-facebook" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-instagram" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#" mr={3}>
                <i className="fab fa-twitter" />
              </MKTypography>
              <MKTypography component="a" variant="body1" color="white" href="#">
                <i className="fab fa-google-plus" />
              </MKTypography>
            </MKBox>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        {data?.extra}
        {/* <Information /> */}
        {/* <Team />
        
        <Newsletter /> */}
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default AboutUs;
